module.exports = __webpack_public_path__ + "img/collections.1cf0bd95.svg";